import * as yup from "yup";
import { validateDaySlots } from "../utils/timeOverlapUtils";
import { requiredField } from "../../../../../common/infrastructure/helpers/yupHelper";

export const timeSlotSchema = yup
  .object({
    id: yup.number().optional(),
    startTime: yup.string().nonNullable().required(requiredField("Начален час")),
    endTime: yup.string().nonNullable().required(requiredField("Краен час")),
  })
  .required();

// Export the inferred slot type
export type IWorkingHoursSlot = yup.InferType<typeof timeSlotSchema>;

const createDayValidation = (dayName: string) => {
  return yup
    .array()
    .of(timeSlotSchema)
    .defined()
    .test("no-overlaps", "", function (slots) {
      if (!slots || slots.length === 0) return true;

      const errorMessage = validateDaySlots(slots, dayName);
      if (errorMessage) {
        return this.createError({ message: errorMessage });
      }

      return true;
    });
};

export const workingHoursFormSchema = yup
  .object({
    studioId: yup.number().nullable().optional().defined(),
    userId: yup.number().nullable().optional().defined(),
    monday: createDayValidation("Понеделник"),
    tuesday: createDayValidation("Вторник"),
    wednesday: createDayValidation("Сряда"),
    thursday: createDayValidation("Четвъртък"),
    friday: createDayValidation("Петък"),
    saturday: createDayValidation("Събота"),
    sunday: createDayValidation("Неделя"),
  })
  .required();

// Export the inferred type from here to avoid circular dependency
export type IWorkingHoursFormModel = yup.InferType<
  typeof workingHoursFormSchema
>;
